/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { browserHistory } from '../../App';

// import { setLastRoute } from '../../core/helpers/lastRoute';
import { useUtils } from '../../core/hooks/useUtils';
import { getUserAction } from '../../store/User/action';

interface IOutput {
	isLoading: boolean;
	checkStatus: () => void;
}

interface HookState {
	isSent: boolean;
}

export default function useHook(): IOutput {
	const {
		dispatch,
		store: { user },
	} = useUtils();

	const [state, setState] = useState<HookState>({
		isSent: false,
	});

	useEffect(() => {
		// setLastRoute('AwaitingApprove');
	}, []);

	useEffect(() => {
		if (!user.data || !isSent) return;
		if (user?.data.approved) {
			browserHistory.push('/my-boards');
		}
	}, [user]);

	const checkStatus = (): void => {
		setState(prev => ({ ...prev, isSent: true }));
		dispatch(getUserAction());
	};

	const { isSent } = state;

	return {
		isLoading: user.isLoading,
		checkStatus,
	};
}
